import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
  tabHeader: {
    id: 'frontbucket.repository.source.sidebar.compass.tabHeader',
    description: 'Tab header for the source sidebar',
    defaultMessage: `{componentCount, plural, =0 {Compass components} one {<strong>1</strong> Compass component} other {<strong>{componentCount}</strong> Compass components}}`,
  },
  collapsedTabHeader: {
    id: 'frontbucket.repository.source.sidebar.compass.tabHeader-collapsed',
    description: 'Tab header for the source sidebar in the collapsed state',
    defaultMessage: 'Compass components',
  },
  collapsedIconLabel: {
    id: 'frontbucket.repository.source.sidebar.compass.tabHeader-collapsed-icon-label',
    description: 'Label for the collapsed tab icon',
    defaultMessage: 'Expand Compass Card',
  },
  expandedIconLabel: {
    id: 'frontbucket.repository.source.sidebar.compass.tabHeader-expanded-icon-label',
    description: 'Label for the expanded tab icon',
    defaultMessage: 'Collapse Compass Card',
  },
});
